import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { BrandMentionPlatform } from '@/types/brandMentions'
import { PlatformIcon } from '@/components/brand-mentions/PlatformIcon'

interface PricingFeatureItemProps {
	text: string
	className?: string
	platforms?: BrandMentionPlatform[]
}

export function PricingFeatureItem({
	text,
	className,
	platforms,
}: PricingFeatureItemProps) {
	const normalizedText = text.replace(/\s*\(?soon\)?\s*$/i, '').trim()

	return (
		<li className={cn('flex items-start gap-2', className)}>
			<span className="mt-0.5 rounded-full bg-primary/10 p-1">
				<Check size={20} className="text-primary" />
			</span>
			<span className="text-muted-foreground">
				{normalizedText}
				{platforms && platforms.length > 0 && (
					<span className="mt-1.5 flex items-center gap-1.5">
						{platforms.map((platform) => (
							<PlatformIcon
								key={platform}
								platform={platform}
								className="h-4 w-4"
								colored
							/>
						))}
					</span>
				)}
			</span>
		</li>
	)
}
